import TibiMatomo from "./src/core/TibiMatomo.js";


;(function(window) {
    // "use strict"; //使用js严格模式检查，使语法更规范
    let _global;

    // 自动监听初始化
    TibiMatomo.autoMonitorInit();

    // 最后将插件对象暴露给全局对象
    _global = (function(){ return this || (0, eval)('this'); }());
    if (typeof module !== "undefined" && module.exports) {
        module.exports = TibiMatomo;
    } else if (typeof define === "function" && define.amd) {
        define(function(){return TibiMatomo;});
    } else {
        !('TibiMatomo' in _global) && (_global.TibiMatomo = TibiMatomo);
    }
}(window));

export default TibiMatomo;